var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("cancel-verification-modal", {
        attrs: { "is-dialog-visible": _vm.isAuthorizationCancelModalVisible },
        on: { visibilityChanged: _vm.setIsAuthorizationCancelModalVisible },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ring-card-action-box__text ring-card-action-box__title",
        },
        [_vm._v("\n    Account Verification\n  ")]
      ),
      _vm._v(" "),
      _vm.isApprovedStatus
        ? _c(
            "div",
            { staticClass: "flex flex-col justify-between content-center" },
            [
              _c("div", { staticClass: "justify-between content-center" }, [
                _vm.expiresAt
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "ring-card-action-box__text ring-card-action-box__description",
                      },
                      [
                        _vm._v("\n        Expires at:  \n        "),
                        _c("time-zone-formatter", {
                          attrs: { "current-time": _vm.expiresAt },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isApprovedStatus
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "ring-card-action-box__text-success ring-card-action-box__text",
                      },
                      [_vm._v("\n        Account Verified\n      ")]
                    )
                  : _vm._e(),
              ]),
            ]
          )
        : _vm.isVerificationRequired
        ? _c(
            "div",
            {
              staticClass:
                "ring-card-action-box__text ring-card-action-box__text-error",
            },
            [_vm._v("\n    Verification Required\n  ")]
          )
        : _vm.isPending
        ? _c(
            "div",
            [
              _c(
                "div",
                {
                  staticClass:
                    "ring-card-action-box__text ring-card-action-box__description",
                },
                [_vm._v("\n      " + _vm._s(_vm.statusMessage) + "\n    ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "ring-card-action-box__text ring-card-action-box__text-warning",
                },
                [_vm._v("\n      Pending\n    ")]
              ),
              _vm._v(" "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    effect: "dark",
                    content: "Cancel current verification authorization",
                    placement: "bottom-start",
                  },
                },
                [
                  _c(
                    "el-link",
                    {
                      staticClass: "cancel-verification",
                      on: { click: _vm.showCancelAuthorizationModal },
                    },
                    [_vm._v("\n        Cancel Verification\n      ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }